import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsSliderThree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSettingsSliderThree"><Path fillRule="evenodd" clipRule="evenodd" d="M6.95123 2.99707V11H4.95123V2.99707H6.95123ZM12.9998 2.99707V7.99902H14.955V9.99902H9.04462V7.99902H10.9998V2.99707H12.9998ZM19.0484 2.99707V13.0008H17.0484V2.99707H19.0484ZM12.9998 12.0005V21.0038H10.9998V12.0005H12.9998ZM2.99609 13.0015H8.90643V15.0015H6.95123V21.004H4.95123V15.0015H2.99609V13.0015ZM15.0932 15.002H21.0035V17.002H19.0484V21.0036H17.0484V17.002H15.0932V15.002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsSliderThree;
